import { hdpApiBase } from '../config/api';

const FLASK_BASE = process.env.REACT_APP_API_URL || '/api';

function detectHdpModule(path) {
  if (path.startsWith('/hdp/evidence') || path.startsWith('/hdp/files')) {
    return 'evidence';
  }
  if (path.startsWith('/hdp/personas')) {
    return 'personas';
  }
  if (path.startsWith('/hdp/iocs') || path.startsWith('/hdp/enrichment')) {
    return 'iocs';
  }
  return 'cases';
}

function resolveBase(path) {
  if (path.startsWith('/hdp/')) {
    return hdpApiBase(detectHdpModule(path));
  }
  return FLASK_BASE;
}

async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refresh_token');
  if (!refreshToken) return null;

  const response = await fetch(`${FLASK_BASE}/auth/refresh`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${refreshToken}` },
  });
  if (!response.ok) return null;

  const data = await response.json().catch(() => ({}));
  if (!data.access_token) return null;

  localStorage.setItem('token', data.access_token);
  return data.access_token;
}

async function authFetch(path, options = {}, retry = true) {
  const token = localStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const base = resolveBase(path);
  const response = await fetch(`${base}${path}`, { ...options, headers });
  if (response.status === 401 && retry) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      headers.Authorization = `Bearer ${newToken}`;
      return fetch(`${base}${path}`, { ...options, headers });
    }
  }
  return response;
}

export async function uploadMultipart(path, formData) {
  const response = await authFetch(path, {
    method: 'POST',
    body: formData,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Upload failed');
  }
  return data;
}

export async function fetchAuthenticatedBlob(path) {
  const response = await authFetch(path);
  if (!response.ok) {
    throw new Error('Failed to load file');
  }
  return URL.createObjectURL(await response.blob());
}

export async function downloadAuthenticatedFile(path, filename) {
  const response = await authFetch(path);
  if (!response.ok) {
    throw new Error('Download failed');
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'download';
  link.click();
  URL.revokeObjectURL(url);
}
